<template>
  <s><slot /></s>
</template>

<script>
export default {
  name: "SbStrike",
  props: {
    blok: {
      type: Object,
      required: false,
    },
  },
};
</script>
